'use client';

import { SvgShoppingBasketFill } from '@common/icon';
import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import { useGiftCart } from '@/app/donation/_hooks/useGiftCart';
import { DONATION_ROUTES } from '@/constants';
import { gtmDatasets } from '@/utils/analytics/gtm';

interface CartIconLinkProps {
  className?: string;
  iconClassName?: string;
}

export const CartIconLink = ({
  className,
  iconClassName,
}: CartIconLinkProps) => {
  const { totalCount } = useGiftCart();
  const hasItems = totalCount > 0;

  return (
    <CustomLink
      href={DONATION_ROUTES.CART.pathname}
      aria-label="장바구니"
      className={cn('relative', className)}
      {...gtmDatasets.clickGnb({ menu_name: '장바구니' })}
    >
      <SvgShoppingBasketFill className={cn('size-24', iconClassName)} />
      {hasItems && (
        <span className="absolute -right-6 -top-4 flex size-16 items-center justify-center rounded-pill bg-R-500 font-700 text-Gray-white typo-caption2">
          {totalCount > 99 ? '99+' : totalCount}
        </span>
      )}
    </CustomLink>
  );
};
